import { UserApi, UserApiResponse } from '../../../api';
import { useContainer } from '../../useContainer';

const useTeamsIntegrationStatus = () => {
    const userApi = useContainer(UserApi);

    const getTeamsIntegrationStatus = (): Promise<UserApiResponse.TeamsIntegrationStatusResponse['body']> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.getTeamsIntegrationStatus({
                onSuccess: res => {
                    const payload = (res.body as { body?: UserApiResponse.TeamsIntegrationStatusResponse['body'] })?.body;
                    resolve(payload ?? res.body);
                },
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { getTeamsIntegrationStatus };
};

export default useTeamsIntegrationStatus;
